import { useTranslator } from "gemi/client";
import { useAuthModal } from "./AuthModalV2";
import { setAuthIntent } from "./authIntent";
import { useLandingSession } from "./useLandingSession";
import { font, SwooshWord } from "./_shared";

export function StudioCTAV2() {
  const t = useTranslator("StudioCTAV2");
  const { user, loading } = useLandingSession();
  const { open: openAuth } = useAuthModal();
  const isAuthenticated = !loading && Boolean(user);
  const studioAuth = () => {
    setAuthIntent({ target: "ai-studio" }, user?.publicId ?? null);
    openAuth("signin");
  };
  // Break the headline after the first sentence to match Figma ("In the studio." on its own line).
  const titleA = t("title_a");
  const dot = titleA.indexOf(". ");
  const line1 = dot >= 0 ? titleA.slice(0, dot + 1) : titleA;
  const line2 = dot >= 0 ? titleA.slice(dot + 2) : "";
  return (
    <section
      className="relative flex w-full flex-col items-center overflow-hidden px-5 py-16 text-center lg:px-16 lg:py-[200px]"
      style={{
        ...font.body,
        background: "linear-gradient(180deg, #343339 0%, #0a0a0a 68%)",
      }}
    >
      <img
        src="/v2/footer/cta-decor-left.jpg"
        alt=""
        aria-hidden
        loading="lazy"
        decoding="async"
        className="absolute left-16 top-12 z-0 hidden h-[291px] w-[215px] rounded-[10px] object-cover lg:block"
      />
      <img
        src="/v2/footer/cta-decor-right.jpg"
        alt=""
        aria-hidden
        loading="lazy"
        decoding="async"
        className="absolute right-[10%] top-6 z-0 hidden h-[122px] w-[163px] rounded-[10px] object-cover lg:block"
      />

      <div className="relative z-10 flex w-full max-w-[620px] flex-col items-center gap-6 lg:max-w-[802px] lg:gap-[34px]">
        <div className="flex flex-col items-center gap-12 lg:gap-11">
          <h2
            className="m-0 text-[48px] font-medium leading-[1.05] tracking-[-1.92px] text-[#e9dcd3] lg:text-[56px] lg:leading-[0.9] lg:tracking-[-2.24px]"
            style={font.display}
          >
            {line1}
            {line2 && (
              <>
                <br />
                {line2}
              </>
            )}
            <SwooshWord id="ctaSwoosh" offset="-0.34em">
              {t("title_field")}
            </SwooshWord>
            .
          </h2>
          <p className="m-0 text-[16px] leading-[1.3] text-white/80 lg:max-w-[514px]">
            {t("subhead")}
          </p>
        </div>
        <div className="flex w-full flex-col gap-4 lg:w-auto lg:flex-row">
          {isAuthenticated ? (
            <a
              href="/app/redirect"
              onClick={() =>
                setAuthIntent({ target: "ai-studio" }, user?.publicId ?? null)
              }
              className="flex h-[50px] w-full items-center justify-center gap-2 rounded-full bg-[#343339] px-8 text-[14px] font-medium text-white no-underline lg:w-auto"
            >
              <img
                src="/v2/icons/desktop.svg"
                alt=""
                aria-hidden
                loading="lazy"
                decoding="async"
                className="size-5"
              />
              {t("open_web_studio")}
            </a>
          ) : (
            <button
              type="button"
              onClick={studioAuth}
              className="flex h-[50px] w-full items-center justify-center gap-2 rounded-full bg-[#343339] px-8 text-[14px] font-medium text-white lg:w-auto"
            >
              <img
                src="/v2/icons/desktop.svg"
                alt=""
                aria-hidden
                loading="lazy"
                decoding="async"
                className="size-5"
              />
              {t("open_web_studio")}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
